import Color from 'color';

// utils
function prepareCustomStyleForLayout(colors) {
  const mainColor = Color(colors.main_color);
  const secondColor = Color(colors.second_color);
  const accentColor = Color(colors.accent_color);

  return `
    .LayoutWrapper__content {
      background-color: ${mainColor};
    }
    .LayoutWrapper__column--left {
      background-color: ${mainColor};
      color: ${mainColor.luminosity() >= 0.50 ? mainColor.darken(0.8).hex() : mainColor.lighten(7).hex()}
    }
    .LayoutWrapper__column--right {
      background-color: ${secondColor};
      color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(7).hex()};
    }
    .LayoutWrapper__contact-content {
      border-top: 1px solid  ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.9).hex() : secondColor.lighten(1).hex()}
    }
    .LayoutWrapper__contact-column--left {
      color: ${accentColor}
    }
    .LayoutWrapper__column--right .el-loading-mask {
      background-color: ${secondColor.alpha(0.7)};
      width: 50%;
      left: auto;
      height: 100%;
      position: fixed;
    }
    @media (max-width: 648px) {
      .LayoutWrapper__column--right .el-loading-mask {
        width: 100%;
      }
    }
    .LayoutWrapper__column--right .el-loading-spinner .path {
      stroke: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()};
    }
    .LayoutWrapper__column--right .el-loading-spinner .el-loading-text {
      color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()};
    }
  `;
}

function prepareCustomStyleForForm(colors) {
  const mainColor = Color(colors.main_color);
  const secondColor = Color(colors.second_color);
  const accentColor = Color(colors.accent_color);

  return `
    .DynamicForm {
      color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()}
    }
    .el-form-item__error {
      left: 0px;
      right: 0px;
      margin-top: 3px;
      text-align: center;
    }
    .el-form-item__content {
      margin-bottom: 20px;
    }
    .el-input-group__prepend {
      font-size: 26px;
      padding: 0 0 0 15px;
      border-right: 0px !important;
      border-radius: 50px 0px 0px 50px;
      transition: border-color .2s cubic-bezier(.645,.045,.355,1);
      color: ${accentColor};
      background: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()};
      border: 1px solid ${accentColor};    
    }
    .el-form-item.is-error .el-input-group__prepend{
      border-color: #f56c6c;
      border-right: 0px !important;
    }
    .el-form-item.is-success .el-input-group__prepend {
      border-color: ${accentColor};
      border-right: 0px !important;
    }         
    .el-input-group__append {
      font-size: 26px;
      border-left: 0px !important;
      border-radius: 0px 50px 50px 0px;
      transition: border-color .2s cubic-bezier(.645,.045,.355,1);
      color: ${accentColor};
      background: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()};
      border: 1px solid ${accentColor};          
    }
    .el-form-item.is-error .el-input-group__append {
      border-color: #f56c6c;
      border-left: 0px;      
    }
    .el-form-item.is-success .el-input-group__append {
      border-color: ${accentColor};
      border-left: 0px !important;
    }               
    .el-input__inner {
      border-left: 0px !important;
      border-right: 0px !important;
      border-radius: 0px 50px 50px 0px;
      height: 45px;
      line-height: 45px;
      padding-left: 4px;
      color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()} !important;
      background: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()};
      border: 1px solid ${accentColor};      
    }
    .el-input__inner:hover {
      background: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()};
      border: 1px solid ${accentColor};       
    }
    .el-input__inner:focus {
      border: 1px solid ${accentColor};
    }
    .DynamicForm .el-form-item.is-success .el-input__inner, .DynamicForm .el-form-item.is-success .el-input__inner:focus {
      border-color: ${accentColor};
    }          
    .el-form-item.is-success .el-input__inner {
      border-color: ${accentColor};
    }
    .el-input.is-disabled {
      opacity: 0.8;
      filter: blur(2px);
    }
    .el-input.is-disabled .el-input__inner {
      background: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()};      
    }
    .ShFormGenerator__label {
      font-size: 14px;
      font-weight: 300;
      line-height: 140%;
      text-align: center;
    }
    .ShFormGenerator__element-login {
      margin-bottom: 20px;
    }
    .ShFormGenerator__link-reminder {
      color: ${accentColor};
      text-align: right;
      text-decoration: none;
    }
    .ShFormGenerator__link-reminder a{
      color: ${accentColor};
      text-decoration: none;
    }
    .DynamicForm .el-form-item {
      position: relative;
    }
    .DynamicForm .el-form-item__label {
      top: 10px;
      z-index: 2;
      left: 50px;
      padding: 0;
      color: #66738F;
      font-size: 8px;
      transition: .3s;
      font-weight: 500;
      line-height: 12px;
      position: absolute;
      visibility: hidden;
      pointer-events:none;
      transition:0.2s ease all; 
      -moz-transition:0.2s ease all; 
      -webkit-transition:0.2s ease all;
    }
    .DynamicForm .focused .el-form-item__label {
      top: 2px;
      visibility: visible;
    }
    .DynamicForm input:focus .el-form-item__label, .DynamicForm input:valid .el-form-item__label {
      top:5px;
      font-size:14px;
      color:#5264AE;
    }
    .DynamicForm .el-form-item__label::before {
      display: none;
    }
    .ShFormGenerator__element-password {
      position: relative;
    }
    .el-checkbox {
      width: 100%;
      text-align: center;
    }
    .el-checkbox-group {
      text-align: center;
    }
    .DynamicForm__resend-code{
      text-align: center;
      margin-top: 20px;
      cursor: pointer;
    }
    .DynamicForm__resend-code--resned {
      text-align: center;
      margin-top: 20px;
    }
    .DynamicForm__resend-code:hover{
      color: ${accentColor};
      text-decoration: underline;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: ${accentColor} !important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: ${accentColor} !important;
      border-color: ${accentColor} !important;
    }
    .el-checkbox__inner:hover, .el-checkbox__inner:focus {
      border-color: ${accentColor} !important;
    }
    .el-button--primary {
      width: 100%;
      height: 45px;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      border-radius: 50px;
      text-transform: uppercase;
      background: ${accentColor};
      color: ${mainColor} !important;
      border-color: ${accentColor} !important;
      transition: background-color .2s cubic-bezier(.645,.045,.355,1);
    }
    .el-button--primary:hover {
      background-color: ${accentColor.lighten(0.1).hex()} !important;
    }
    .el-button--primary:focus {
      background: ${accentColor.lighten(0.1).hex()} !important;
    }
    .el-button--warning {
      border-color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()};
      color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()};     
    }
    .el-button--warning:hover {
      border-color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()};
      color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()};
      background: ${secondColor.luminosity() >= 0.50 ? secondColor.fade(0.2).darken(0.8).hex() : secondColor.fade(0.2).lighten(0.2).hex()};     
    }
    .el-button--warning:focus {
      border-color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()};
      color: ${secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()};
      background: ${secondColor.luminosity() >= 0.50 ? secondColor.fade(0.2).darken(0.8).hex() : secondColor.fade(0.2).lighten(0.2).hex()};         
    }
  `;
}

// export service
export default class BrandService {
  static generateBrandTheme(colors) {
    return {
      layout: prepareCustomStyleForLayout(colors),
      form: prepareCustomStyleForForm(colors),
      additionalStyles: colors.additional_styles,
    };
  }
}



// WEBPACK FOOTER //
// ./src/services/BrandService.js